import "./Topbar.css";
import leftArrow from "../../../../../../assets/left-arrow.png";
const Topbar = ({ setActive, text, back }) => {
 return (
  <div className="settings-mobile-topbar">
   <img src={leftArrow} alt="arrow-left" onClick={() => setActive(back)} />
   <p>{text}</p>
   <p></p>
  </div>
 );
};

export default Topbar;
